import Tracker from '~/src/common/services/Tracker';

import { PropsFromInputs } from '../../types';

import { StyledLink } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

// Utiliser la prop defaultValue dans les inputs serait préférable mais génerait un souci de typing
export default ({
  text = 'Texte du bouton',
  link,
  variant = 'primary',
  openLinkInNewTab,
  builderContext,
}: Props) => {
  const handleClick = () => {
    const metaTitle = builderContext?.content?.data?.metaTitle;
    const url = builderContext?.content?.data?.url;

    Tracker.sendEvent('click cta', {
      'cta button text': text,
      'current page name': metaTitle,
      'current page path': url,
    });
  };

  // Permet de forcer le type en union de string
  const buttonVariant =
    variant === 'primary' ? 'primary' : variant === 'secondary' ? 'secondary' : 'tertiary';

  return (
    <StyledLink
      href={link}
      variant={buttonVariant}
      onClick={handleClick}
      target={openLinkInNewTab ? '_blank' : '_self'}>
      {text}
    </StyledLink>
  );
};
